import SessionEditModal from './SessionEditModal';

export default SessionEditModal;
